import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CalendarFollowUpIcon} from 'shells/icon/svg/calendar-follow-up-icon';
// @ts-expect-error - imported from .js/.jsx file
import {CalendarPreviousIcon} from 'shells/icon/svg/calendar-previous-icon';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {GetActivityForModal_activity_previousActivity as FollowUpActivity} from 'nutshell-graphql-types';

import {getActivityLink} from './helpers';

import styles from './internal-notes.module.css';

type FollowUpItemProps = {
    icon: React.ComponentType<{
        alignCenter: boolean;
        size: number;
        color: string;
    }>;
    text: string;
    linkText: string;
    href: string;
};

function FollowUpItem(props: FollowUpItemProps) {
    const Icon = props.icon;

    return (
        <div className='flex gap-8'>
            <Icon alignCenter={true} size={15} color={colors.blue} />
            <div className='flex gap-4'>
                <Body size='small'>{props.text}</Body>
                <Link variant='primary' size='small' href={props.href}>
                    {props.linkText}
                </Link>
            </div>
        </div>
    );
}

type Props = {
    previousActivity: FollowUpActivity | null | undefined;
    nextActivity?: FollowUpActivity | null | undefined;
};

export function FollowUpBanner(props: Props) {
    return (
        <div className={styles['follow-up-banner']}>
            {props.previousActivity && (
                <FollowUpItem
                    icon={CalendarPreviousIcon}
                    text='Previous:'
                    linkText={props.previousActivity.name}
                    href={getActivityLink(props.previousActivity.id)}
                />
            )}
            {props.nextActivity && (
                <FollowUpItem
                    icon={CalendarFollowUpIcon}
                    text='Follow-up:'
                    linkText={props.nextActivity.name}
                    href={getActivityLink(props.nextActivity.id)}
                />
            )}
        </div>
    );
}
